module.exports = __webpack_public_path__ + "static/media/C98-BNB.af0dcd08.svg";